import type { CreateEventRequest, CreateEventResponse } from '@cibli/shared';

import api from './api';

/**
 * Créer un événement analytics.
 *
 * Le backend gère automatiquement les sessions :
 * - SESSION_STARTED : crée une EventSession et retourne l'eventSessionId
 * - SESSION_ENDED : clôt la session (met endedAt)
 * - Autres events : stocke simplement l'event
 */
export async function createEvent(data: CreateEventRequest): Promise<CreateEventResponse> {
  return await api.post<CreateEventResponse, CreateEventRequest>('/analytics/events', data);
}

/**
 * Créer plusieurs événements analytics en une requête (ex: JOB_LISTED en batch).
 * SESSION_STARTED n'est pas autorisé dans le batch.
 */
export async function createEventsBatch(data: CreateEventRequest[]): Promise<{ created: number }> {
  if (data.length === 0) return { created: 0 };
  return await api.post<{ created: number }, CreateEventRequest[]>('/analytics/events/batch', data);
}

/**
 * Mettre à jour une EventSession (par exemple pour ajouter la langue après sélection)
 */
export async function updateEventSession(
  eventSessionId: string,
  data: { language?: string },
): Promise<void> {
  await api.patch(`/analytics/event-sessions/${eventSessionId}`, data);
}
